export const viewClaimMetaData1: any[] = [
    {
        keys: "claimDate",
        label: "Claim Date",
        index: 1,
    },
    {
        keys: "approvalDate",
        label: "Approval Date",
        index: 2,
    },
    {
        keys: "claimType",
        label: "Claim Type",
        index: 3,
    },
    {
        keys: "typeOfExpense",
        label: "Type of Expense",
        index: 4,
    },
    {
        keys: "selectedMonth",
        label: "Selected Month",
        index: 5,
    },
];

export function viewClaimMetaData2(currencySymbol: string, status: string, claimType: string, typeOfExpense: string, statusConfig:any): any[] {
    const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
    const {claimTypes, claimSubTypes} = ConfigDictionary;
    const updatedStatusConfig = statusConfig.map((config:any) => ({
        ...config,
        id: config.id?.toUpperCase(),
      }));

    const valueStyle = {
        fontSize: "15px",
        fontWeight: 600
    };

    const qtyColumns = [
        { keys: "totalQuantities", label: "Claim Qty", index: 1 },
        { keys: "approvedTotalQuantities", label: "Approved Qty", index: 2 },
        { keys: "claimAmount", label: "Claim Amount", index: 3, currencySymbol, valueType: "Number" },
        { keys: "approvedClaimAmount", label: "Approved Claim Amount", index: 4, currencySymbol, valueType: "Number", valueStyle: valueStyle}
    ];

    const qtyWithRejected = [
        { keys: "totalQuantities", label: "Claim Qty", index: 1 },
        { keys: "approvedTotalQuantities", label: "Approved Qty", index: 2 },
        { keys: "rejectedTotalQuantities", label: "Rejected Qty", index: 3, valueType: "Array" },
        { keys: "claimAmount", label: "Claim Amount", index: 4, currencySymbol, valueType: "Number" },
        { keys: "approvedClaimAmount", label: "Approved Claim Amount", index: 5, currencySymbol, valueType: "Number", valueStyle: valueStyle }
    ];

    const assetColumns = [
        { keys: "assetQty", label: "Asset Qty", index: 1 },
        { keys: "assetApprovedQty", label: "Approved Qty", index: 2 },
        { keys: "claimAmount", label: "Claim Amount", index: 3, currencySymbol, valueType: "Number" },
        { keys: "approvedClaimAmount", label: "Approved Claim Amount", index: 4, currencySymbol, valueType: "Number", valueStyle: valueStyle }
    ];

    const amountOnly = [
        { keys: "claimAmount", label: "Claim Amount", index: 3, currencySymbol, valueType: "Number" },
        { keys: "approvedClaimAmount", label: "Approved Claim Amount", index: 4, currencySymbol, valueType: "Number", valueStyle: valueStyle }
    ];
    
    if (typeOfExpense === claimSubTypes[4]) return amountOnly;
    if (typeOfExpense === claimSubTypes[5]) return assetColumns;

    switch (status) {
        case updatedStatusConfig[3].id:
            if (claimType === claimTypes[2]) return qtyColumns;
            return qtyWithRejected;
        default:
            return qtyColumns;
    }
}